import postGarbageCollectionTask from '../luna-tasks/schemas/postGarbageCollectionTask';
import {
  eventToEvent,
  postStatistic,
  generalWsToEvent,
  readEmitEvent,
  wsToEvent,
  getGeneralWsEventsQS,
  generalEventToEvent,
} from './events/mappers';
import { schemes as facesSchemes } from './faces';
import { schemes as handlerSchemes } from './handlers/mappers/schemes';
import { schemes as isoSchemes } from './iso';
import { schemes as matcherSchemes } from './matcher';
import { schemes as objectsSchemes } from './objects';
import { schemes as streamsSchemes } from './streams';
import { schemes as taskSchemes } from './tasks';
import { getToken } from './tokens/getToken';
import { postToken } from './tokens/postToken';
import { schemes as verifierSchemes } from './verifiers';
import { schemes as videosdkSchemes } from './videosdk';

export function buildSchemaProxy(client) {
  return {
    verifiers: {
      read: verifierSchemes.read,
      create: verifierSchemes.create,
      readVerifyResults: verifierSchemes.readVerifyResults,
    },
    tasks: {
      exporter: taskSchemes.exporter,
      estimator: taskSchemes.estimator,
      crossmatch: taskSchemes.crossmatch,
      postGCTask: postGarbageCollectionTask,
    },
    objects: {
      create: objectsSchemes.createResp(client),
    },
    matcher: {
      searchFiltersMapper: matcherSchemes.searchFiltersMapper,
      read: matcherSchemes.read(client),
    },
    iso: {
      read: isoSchemes.read,
      isoQS: isoSchemes.isoQS,
    },
    handlers: {
      read: handlerSchemes.read,
      create: handlerSchemes.create,
    },
    videosdk: {
      create: videosdkSchemes.create,
    },
    faces: {
      read: facesSchemes.read(client),
      create: facesSchemes.create,
      facesQS: facesSchemes.getFacesQS,
      facesCountQS: facesSchemes.getFacesCountQS,
    },
    events: {
      read: eventToEvent(client),
      generalWsToEvent: generalWsToEvent(client),
      generalEventToEvent: generalEventToEvent(client),
      getGeneralWsEventsQS,
      wsToEvent,
      readEmitEvent,
      postStatistic,
    },
    tokens: {
      post: postToken,
      get: getToken,
    },
    streams: {
      create: streamsSchemes.create,
      read: streamsSchemes.read,
    },
  };
}
